import { getTenant } from './getTenant';

export function toAbsoluteUrl(pathname) {
	const uri = pathname.replace(/\s/g, '%20');
	const { protocol } = window.location;
	const tenant = getTenant();

	if (uri.startsWith('http') || uri.startsWith('data:')) {
		return uri;
	}

	if (!uri.startsWith('/')) {
		return `${protocol}//${tenant}/${uri}`;
	}

	return `${protocol}//${tenant}` + uri;
}
